import { cacheIsValid, deleteContent, refreshCacheKey, safeGetItem, safeSetItem } from '@shared/cache/cache.browser';
import { log } from '@shared/log.browser.ts';

const CONTENT_KEY = 'reptile_dundee_cacheContent';

export async function saveToCache<T>(data: T) {
    await safeSetItem(CONTENT_KEY, JSON.stringify($state.snapshot(data)));
}

export async function maybeRestoreFromCache<T>(data: T) {
    let result = data;

    if (await cacheIsValid()) {
        const cachedTileList = await safeGetItem(CONTENT_KEY);
        if (cachedTileList) {
            try {
                const parsed: T = JSON.parse(cachedTileList);
                result = parsed;
            } catch (error) {
                log.error('Failed to parse cached tileList:', error);
            }
        }
    }

    await refreshCacheKey();
    await deleteContent(CONTENT_KEY);

    return result;
}
